import { render } from "./UserPasswordUpdate.vue?vue&type=template&id=33c1ba54"
import script from "./UserPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./UserPasswordUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__